<template>
  <div class="footer d-print-none">
    <div class="footer-left d-flex justify-space-between">
      <!-- online state -->
      <v-menu top open-on-hover offset-x offset-y>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" class="ml-n1 pr-5">
            {{ userList.length }}
          </span>
        </template>

        <v-list v-if="user && user.rights.admin" dense>
          <v-list-item v-for="(user, u) in userList" :key="u">
            <v-avatar
              size="32"
              :color="
                user.avatar == '' ? 'grey lighten-4' : 'rgb(0, 0, 0, 0.0)'
              "
              style="font-size: 75%"
              class="mr-2"
            >
              <span v-if="user.avatar == ''">
                {{ user.id | INITIALS }}
              </span>
              <img v-else :src="user.avatar" style="height: auto" />
            </v-avatar>
            <v-list-item-title>
              <v-list-item-title>{{ user.id | FULLNAME }}</v-list-item-title>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <span>
        <span class="left-1"
          >PAUSCH Medical GmbH
          <span class="d-none d-sm-inline"> - ein Unternehmen der </span>
        </span>
        <span class="left-2 d-none d-sm-inline">MAVIG G</span>
        <span class="left-3 d-none d-sm-inline">ROUP</span>
      </span>
    </div>
    <div class="footer-right text-center">
      <span class="d-none d-md-inline" id="footer-info">&nbsp;</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  created() {},
  computed: {
    ...mapGetters(['user', 'allUser', 'FULLNAME']),
    userList() {
      return this.allUser
        .filter((user) => user.status.online)
        .sort((a, b) =>
          this.FULLNAME(a.name) > this.FULLNAME(b.name) ? 1 : -1
        )
    },
  },
  watch: {},
  methods: {},
  beforeDestroy() {},
  components: {},
}
</script>

<style scoped>
.footer {
  position: relative;
  display: contents;
  font-size: 12px;
}

.footer > div {
  height: 26px;
  padding: 5px 15px;
  color: #fff;
}

.footer-left {
  width: 80%;
  border-right: 1px solid #fff;
  background-color: #283273;
  font-family: Arial;
  text-align: right;
}

.left-1 {
  font-style: italic;
}

.left-2 {
  font-weight: bold;
}

.left-3 {
  font-weight: bold;
  text-transform: capitalize;
  font-size: 66%;
}

.footer-right {
  width: 20%;
  border-left: 1px solid #fff;
  background-color: #428bca;
}

#footer-info {
  font-size: 9px;
  color: #ccc;
}
</style>
